import { AStar } from './AStar';
import { Graph } from './Graph';

export class Pathfinder {
    /**
     *
     * @param {Graph} graph
     * @param {AStar} algorithm
     */
    constructor(graph, algorithm, opts) {
        this.graph = graph.collisions;
        this.algorithm = algorithm;
        this.opts = opts;
    }

    pathTo(startPos, endPos) {
        return this.algorithm.search(this.graph, this.graph.getNodeFromXY(startPos), this.graph.getNodeFromXY(endPos), this.opts);
    }
}
